import { NotifyHelper } from "../../../helpers/toast";
import { objDangKyAnHocSinhDefine } from "../../action-types/thuc-don/IFoDangKyAnHocSinhActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const foDangKyAnHocSinhActions = {
    ...generateActions(objDangKyAnHocSinhDefine, "DANG_KY_AN_HOC_SINH"),
    ...generateActionForKey(objDangKyAnHocSinhDefine, "DANG_KY_AN_HOC_SINH",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDangKyAnHocSinhDefine, "DANG_KY_AN_HOC_SINH",
        "SAVE_SUCCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objDangKyAnHocSinhDefine, "DANG_KY_AN_HOC_SINH",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDangKyAnHocSinhDefine, "DANG_KY_AN_HOC_SINH",
        "SAVE_IMPORT_SUCCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objDangKyAnHocSinhDefine, "DANG_KY_AN_HOC_SINH",
        "SAVE_IMPORT_ERROR", (m: any) => NotifyHelper.Error(m)),
};
